// update state
const setFolderNameAction = (payload) => {
    return {
        type: "FOLDERNAME",
        payload
    }

}

export default setFolderNameAction;




// WEBPACK FOOTER //
// ./src/actions/setFolderNameAction.js